import { privateApi } from '@configs/axios-instances';
import {
  IntegrationResponseType,
  IntegrationParamsType,
  CreateIntegrationParamsType,
} from '@account_module/types/Integration';

/**
 * Fetch Integrations
 * @return {Promise<IntegrationResponseType>}
 */
export const fetchIntegration = async (): Promise<IntegrationResponseType> => {
  return await privateApi.get('/integrations');
};

/**
 * Update Create Integration
 * @param {CreateIntegrationParamsType} params
 * @return {Promise<IntegrationResponseType>}
 */
export const createIntegrationProgress = async (
  params: CreateIntegrationParamsType
): Promise<IntegrationResponseType> => {
  return await privateApi.post('/integrations', params);
};

/**
 * Update Integration
 * @param {string} id
 * @param {IntegrationParamsType} params
 * @return {Promise<IntegrationResponseType>}
 */
export const updateIntegration = async (
  id: number,
  params: IntegrationParamsType
): Promise<IntegrationResponseType> => {
  return await privateApi.put(`/integrations/${id}`, params);
};

/**
 * Update Integration
 * @param {string} id
 * @param {IntegrationParamsType} params
 * @return {Promise<IntegrationResponseType>}
 */
export const createIntegration = async (
  id: number,
  params: IntegrationParamsType
): Promise<IntegrationResponseType> => {
  return await privateApi.post(`/integrations/${id}`, params);
};
